// extracted by mini-css-extract-plugin
export default {"root":"xWsj5_Wk","backButton":"P2bhPLw0","backIcon":"FmQAR1hK","title":"kW1ssngj"};